export default {
    "title_en": "title english",
    "title_ar": "title arabic",
    "Logout" : "Logout",
    "lang" : "عربي",
    "Create" : "Create",
    "Title En" : "English Title",
    "Title Ar" : "Arabic Title",
    "AssetItem": "Asset / Item",
    "AssetItemCategory":"Asset / Item Category",
    "AssetItem Ecri": "Asset / Item Ecri",
    "AssetItem Utility": "Asset / Item Utility",
    "AssetItem Group": "Asset / Item Group",
    "AssetItem Type": "Asset / Item Type",
    "AssetItem UOM": "Asset / Item UOM",
    "AssetItem Risk Class": "Risk Class",
    "AssetItemCategoryOption": "Asset / Item Category Option",
    "AssetItemGroupOption":"Asset / Item Group Option",
    "Supplier Manufacturer": "Supplier / Manufacturer",
    "SupplierManufacturerStatus":"Supplier Manufacturer Status",
    "CustomerStatus":"Customer Status",
    "Assign Asset Item":"Assign Asset / Item",
    "CoverageType":"Coverage / Type",
    "MeasuringPeriod":"Measuring Period",
    "PenaltyUOM":"Penalty UOM",
    "PenaltyUom":"Penalty UOM",
    "LaborManagement":"Labor Management",
    "ProjectStage":"Project Stage",
    "projectStage":"Project Stage",
    "ProjectStatus":"Project Status",
    "projectStatus":"Project Status",
    "RoomSpace":"Room Space",
    "RoomSpaceCategory":"RoomSpace Category",
    "roomSpaceCategory":"Roomspace Category",
    "RoomSpaceItem":"Allocate Asset / Item",
    "SparePartManagement":"Spare Part Management",
    "AssignTicket":"Assign Ticket",
    "Ticket":"Ticket / Request",
    "TicketStatus":"Ticket Status",
    "WorkOrder":"Work Order",
    "WorkOrderFailureType":"Failure Type",
    "WorkOrderStatus":"Work Order Status",
    "WorkOrderType":"Work Order Type",
    "WorkOrderCategory":"Work Order Category",
    "PlanPreventiveMaintenance":"Plan Preventive Maintenance",
    "Name en":"Name in english",
    "Name ar":"Name in arabic",
    "MedicalUse":"Medical Use ?",
    "AssetDetails":"Asset Details",
    "CommonName":"Common Name",
    "commonName":"Common Name",
    "SerialNumber":"Serial Number",
    "serialNumber":"SerialNumber",
    "BatchNo.":"Batch No.",
    "LOTNO.":"LOT NO.",
    "TechnicalDetails":"Technical Details",
    "RiskClass":"Risk Class",
    "IntendedUse":"Intended Use",
    "ShelfLife":"Shelf Life",
    "CutSheet":"Cut Sheet",
    "Issparepart":"Is spare part ?",
    "OptionTitleEn":"Option Title in english",
    "OptionTitleAr":"Option Title in arabic",
    "ecriName":"Ecri Name",
    "ecriCode":"Ecri Code",
    "Asset/ItemCategory":"Asset / Item Category",
    "Embedlocation":"Embed location",
    "FacilityFloor":"Facility Floor",
    "facilityBuilding":"facility Building",
    "facilityRoom":"facility Room",
    "facilityDepartment":"facility Department",
    "facilityRoomRef.":"facility Room Ref.",
    "CustomerSLA":"Customer SLA",
    "customerSLA":"Customer SLA",
    "GeneralDetails":"General Details",
    "AssetName":"Asset Name",
    "SoftwareVersion":"Software Version",
    "ManufacturingDate":"Manufacturing Date",
    "PurchaseOrder":"Purchase Order",
    "PODate":"Purchase Order Date",
    "POReference":"Purchase Order Reference",
    "POValue":"Purchase Order Value",
    "DocumentParent":"Document Group",
    "ChildCategory":"Document Group Type",
    "OptionKey":"Option Key",
    "OptionValue":"Option Value",
    "assign_asset_item":"Assign Asset / Item",
    "contract_value":"contract value",
    "coverage_type": "Coverage Type",
    "response_time":"Response time",
    "repair_time":"Repair time",
    "measuring_period":"measuring period",
    "from_date":"from date",
    "to_date":"to date",
    "penalty_rate":"penalty rate",
    "penalty_uom":"penalty UOM",
    "import_grace_period":"import grace period",
    "purchase_requisition_ref":"purchase requisition ref",
    "supplier_quotation_ref":"supplier quotation ref",
    "purchase_order_ref":"purchase order ref",
    "asset_code":"Asset code",
    "penalty_uom_id":"Penalty UOM",
    "est_cost":"Est cost",
    "actual_cost":"Actual cost",
    "projectPhase":"Project Phase",
    "ProjectDetails":"Project Details",
    "ProjectName":"Project Name",
    "ProjectVersion":"Project Version",
    "ProjectReference":"Project Reference",
    "RoomSpaceName":"Room Space Name",
    "RoomSpaceRef":"RoomSpace Ref",
    "RoomQuantity":"Room Quantity",
    "roomQuantity":"Room Quantity",
    "Manufacturer_part_no":"Manufacturer part number",
    "manufacturer_part_no":"Manufacturer part number",
    "wo_reference":"work order reference",
    "created_date":"created date",
    "start_date":"start date",
    "finish_date":"finish date",
    "closed_date":"closed date",
    "Closed_date":"closed date",
    "Requested_by":"Requested by",
    "assigned_to":"assigned to",
    "failure_type":"failure type",
    "Requester_signing_off":"Requester signing off",
    "Contract_id":"Contract",
    "priority_id":"priority",
    "Customer Category":"Customer Category",
    "Customer Status":"Customer Status",
    "Assign Asset / Item Status":"Assign Asset / Item Status",
    "ProjectPhase":"Project Phase",
    "Project Stage":"Stage",
    "Project Status":"Project Status",
    "Room Space Category":"Room Space Category",
    "Room Space Item":"Room Space Item",
    "Work Order Failure Type":"Work Order Failure Type",
    "Work Order Status":"Work Order Status",
    "Work Order Type":"Work Order Type",
    "Work Order Category":"Work Order Category",
    "Customer status":"Customer status",
    "customer Status":"customer Status",
    "RoomsSpaces":"Room Spaces",
    "RoomSpace Name":"RoomSpace Name",
    "AssignAssetItem":"Assign Asset / Item",
    "AssetLocation":"Asset Location",
    "assignAssetItem":"Assign Asset / Item",
    "measuringPeriod":"Measuring Period",
    "roomSpaceRef":"Room Space Ref",
    "created_by":"created by",
    "requested_by":"Requested by",
    "request_description":"request description",
    "closed_by":"closed by",
    "requester_signing_off":"requester signing off",
    "contract_id":"contract",
    "failureType":"failure Type",
    "PMFrequency":"PM Frequency",
    "QAFrequency":"QA Frequency",
    "CalibrationFrequency":"Calibration Frequency",
    "InstallationDate":"Installation Date",
    "InServiceDate":"In Service Date",
    "ExpireDate":"Expire Date",
    "Welcome to AEON ":"Welcome to AEON",
    "AssetItem View":"Asset / Item View",
    "Customer View":"Customer View",
    "isMedicalUse":"Is Medical Use ?",
    "isSparePart":"Is Spare Part ?",
    "SupplierManufacturer":"Supplier / Manufacturer",
    "Additional":"Setting / Configure",
    "Role":"User Group",
    "AssetItemRiskClass":"Asset / Item Risk Class",
    "CreateAssetItem":"Create Asset / Item",
    "Asset/ItemMasterData":"Asset / Item Master Data",
    "Asset/ItemStatus":"Asset / Item Status ",
    "Supplier/Manufacturer":"Supplier / Manufacture",
    "WarrantyStartDate":"Warranty Start Date",
    "WarrantyEndDate":"Warranty End Date",
    "Asset/ItemRef.":"Asset / Item Ref.",
    "TechnicalDetials":"Technical Detials",
    "Intendeduse":"Intended use",
    "Asset/ItemCommonName":"Asset / Item Common Name",
    "ECRIName":"ECRI Name",
    "SupplierStatus":"Supplier Status",
    "SupplierRanking":"Supplier Ranking",
    "DepreciationRate":"Depreciation Rate",
    "PMType":"PM Type",
    "Asset/ItemName":"Asset / Item Name",
    "PurchaseOrderDate":"Purchase Order Date",
    "Asset/ItemGroup":"Asset / Item Group",
    "Procurement/Installation":"Procurement / Installation",
    "DownloadDocument":"Download Document",
    "ItemReference":"Item Reference",
    "LOTNo.":"LOTNo.",
    "Asset/ItemRef.Generation":"Asset / Item Ref. Generation",
    "TitleorImage":"Title or Image",
    "Reset":"Reset",
    "CustomerName":"Customer Name",
    "CustomerCategory":"Customer Category",
    "SiteName":"Site Name",
    "SiteBuilding":"Site Building",
    "SiteDepartment":"Site Department",
    "SiteFloor":"Site Floor",
    "SiteRoom":"Site Room",
    "SiteWarehouse":"Site Warehouse",
    "TicketType":"Ticket Type",
    "TicketSubType":"Ticket Sub Type",
    "FromDate":"From Date",
    "ToDate":"To Date",
    "toDate":"To Date",
    "Contract_ref":"Contract ref",
    "intendeduse":"Intended use",
    "ContractType":"Contract Type",
    "PlanPreventiveMaintenanceType":"Plan Preventive Maintenance Type",
    "AssetItemUtilityInput":"Asset / Item Utility Input",
    "AssetItemDocumentationGroup":"Document Group",
    "AssetItemDocumentationGroupType":"Document Type",
    "DocumentationGroup":"Document Group",
    "DocumentationGroupType":"Document Type",
    "AssignAssetItemStatus":"Asset / Item Status",
    "PODateFrom":"PO Date From",
    "PODateTo":"PO Date To",
    "InstallationDateFrom":"Installation Date From",
    "InstallationDateTo":"Installation Date To",
    "AssignAsset/ItemRef.":"Assign Asset / Item Ref.",
    "SubCustomer":"Sub Customer",
    "StartDateFrom":"Start Date From",
    "StartDateTo":"Start Date To",
    "AlternativeAsset/ItemRef. ":"Alternative Asset/Item Ref. ",
    "EcriName":"Ecri Name",
    "EcriCode":"Ecri Code",
    "AlternativeAsset/ItemRef.":"Alternative Asset / Item Ref.",
    "TicketCategory":"Ticket Category",
    "TicketSub-Category":"Ticket Sub-Category",
    "ConvertedtoWO":"Converted to WO",
    "AllocateAsset/ItemRef.":"Allocate Asset / Item Ref.",
    "WOCategory":"WO Category",
    "WOType":"WO Type",
    "WOStatus":"WO Status",
    "WODateFrom":"WO Date From",
    "WODateTo":"WO Date To",
    "Assignedto":"Assigned to",
    "RequestedBy":"Requested By",
    "ClosedBy":"Closed By",
    "CreatedBy":"Created By",
    "FailureType":"Failure Type",
    "created_on":"Created on",
    "AllocateAsset/Item":"Allocate Asset / Item",
    "StartDate":"Start Date",
    "EndDate":"End Date",
    "ContractRef.":"Contract Ref.",
    "coverageType":"Coverage Type",
    "InventoryTaking":"Inventory Taking",
    "ProjectFacility":"Project Facility",
    "ProjectFacilityBuilding":"Project Facility Building",
    "ProjectFacilityBuildingFloor":"Project Facility Building Floor",
    "TypicalSpace":"Typical Space",
    "SpaceRef.":"Space Ref.",
    "Asset/Items":"Asset / Items",
    "WorkOrderCost":"WorkOrder Cost",
    "WorkOrderAttachment":"WorkOrder Attachment",
    "WorkOrderStatusHistory":"WorkOrder Status History",
    "WorkOrderActionOption":"WorkOrder Action Option",
    "WorkOrderAction":"WorkOrder Action",
    "PeriodName":"Period Name",
    "Preview Attachment":"Preview Attachment",
    "assigneduser":"Assigned Technical Staff",
    "Notassignedtoanyuser":"Not assigned to any user",
    "SerialNo":"Serial No.",
    "RoomSpaceItemName": "Asset / Item name",    
    // Chat Feature Translations
    "Chat Assistant": "Ai Assistant",
    "Open chat": "Open chat",
    "Close chat": "Close chat",
    "New messages": "New messages",
    "New conversation": "New conversation",
    "Ask about your data...": "Ask about your data...",
    "Send message": "Send message",
    "Type your message": "Type your message",
    "Attach current view": "Attach current view",
    "Context attached": "Context attached",
    "Remove context": "Remove context",
    "No context available": "No context available",
    "I can see you're viewing": "I can see you're viewing",
    "Dismiss context banner": "Dismiss context banner",
    "Your message": "Your message",
    "Assistant message": "Assistant message",
    "Assistant is typing": "Assistant is typing",
    "Yesterday": "Yesterday",
    "Ask questions about your data": "Ask questions about your data",
    "Get insights, analyze trends, and explore your assets through conversation.": "Get insights, analyze trends, and explore your assets through conversation.",
    "Try asking": "Try asking",
    "What's the total value of selected assets?": "What's the total value of selected assets?",
    "Show me flagged items": "Show me flagged items",
    "Summarize the current view": "Summarize the current view",
    "Scroll to bottom": "Scroll to bottom",
    "Chat messages": "Chat messages",
    "Current View": "Current View",
    "Success": "Success",
    "An error occurred during upload.": "An error occurred during upload.",
    "Validation error": "Validation error",
    "Please select a file to upload": "Please select a file to upload",
    "Failed to replan ticket": "Failed to replan ticket",
    "Ticket has been replanned": "Ticket has been replanned",
    "An error occurred": "An error occurred",
    "Please select the room": "Please select the room",
    "Please scan Asset/Item QR code": "Please scan Asset/Item QR code",
    "Are you sure?": "Are you sure?",
    "You won't be able to revert this!": "You won't be able to revert this!",
    "Yes": "Yes",
    "Replan": "Replan",
    "Ticket has been Closed": "Ticket has been Closed",
    "Ticket has been Deleted": "Ticket has been Deleted",
    "Ticket has been Replanned": "Ticket has been Replanned",
    "Upload Errors": "Upload Errors",
    "Errors Detected": "Errors Detected",
    "Validation Errors": "Validation Errors",
    "Please review the details below and correct the issues before re-submitting.": "Please review the details below and correct the issues before re-submitting.",
    "Search in errors...": "Search in errors...",
    "Copy All": "Copy All",
    "Copied!": "Copied!",
    "Download Log": "Download Log",
    "Error List": "Error List",
    "No errors match your search.": "No errors match your search.",
    "Copy this error": "Copy this error",
    "Row": "Row",
    "Error": "Error",
    "Errors": "Errors",
    "Showing": "Showing",
    "of": "of",
    "issues recorded": "issues recorded",
    "issue recorded": "issue recorded"
}
